module.exports = __webpack_public_path__ + "img/default-bg.d87406ad.png";